module.exports = __webpack_public_path__ + "static/media/noImg.a5f68891.png";